import { useState } from "react";
import { Form, Button, Modal } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import CurrencyForm from "./form/CurrencyForm";
import { currencyRegisterAsync } from "../../../app/store/reducers/currency/currencyReducer";



const RegisterCurrenciesModal = () => {
  const [form] = Form.useForm()
  const [show, setShow] = useState(false);
  const showModal = () => {
    setShow(true);
  };
  const handleCancel = () => {
    setShow(false);
    form.setFieldValue("name", "")
    form.setFieldValue("amount", 0)
  };

  const onSubmit = async (values) => {
    console.log("values", values);
    await currencyRegisterAsync(values)
      .then((response) => {
        console.log("success reg category", response.data);
        handleCancel()
      })
      .catch((error) => {
        console.log(error);
      })
  }

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onSubmit(values)
        console.log("values", values)
        form.resetFields();
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };


  return (
    <>
      <Button type="primary" className="d-flex align-items-center justify-content-center" onClick={showModal}>
        <PlusOutlined /> Add
      </Button>
      <Modal 
        title="Register Currency" 
        open={show} 
        okText="Add"
        cancelText="Cancel"
        onOk={handleOk} 
        onCancel={handleCancel}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
        >
          <CurrencyForm/>
        </Form>
      </Modal>
    </>
  );
}

export default RegisterCurrenciesModal